import { useEffect, useState } from 'react';
import Seo from '../../components/Seo/Seo';
import { useNavigate } from 'react-router-dom';
import { getBatteryList, type Product } from '../../api/products';
import { useVehicle } from '../../context/VehicleContext';
import { useCartContext } from '../../context/CartContext';
import Gjkereso from '../../components/Gjkereso/Gjkereso';
import AkkuBox from '../../components/AkkuBox/AkkuBox';

export default function AkkuvalasztoPage() {
	const v = useVehicle();
	const { addToCart } = useCartContext();
	const navigate = useNavigate();
	const [batteries, setBatteries] = useState<Product[]>([]);
	const [loading, setLoading] = useState(false);

	const vehicleId = v.selectedVehicleId;
	const carLabel = [
		v.brandOptions.find((o) => o.value === v.selectedBrand)?.label,
		v.typeOptions.find((o) => o.value === v.selectedType)?.label,
	].filter(Boolean).join(' ');

	useEffect(() => {
		if (!vehicleId) { setBatteries([]); return; }
		let active = true;
		setLoading(true);
		getBatteryList(vehicleId)
			.then((res) => {
				if (!active) return;
				// /battery/list returns an object keyed by product id (not an array),
				// so normalise to a list before mapping — same as VehicleContext does.
				const data = res.data?.data ?? {};
				const raw = (Array.isArray(data) ? data : Object.values(data)) as Product[];
				setBatteries(raw.map((p) => ({ ...p, price: Number(p.price), voltage: Number(p.voltage), capacity: Number(p.capacity), cca: Number(p.cca) })));
			})
			.catch(() => active && setBatteries([]))
			.finally(() => active && setLoading(false));
		return () => { active = false; };
	}, [vehicleId]);

	function order(product: Product) {
		addToCart({ productId: product.id, name: product.name, price: Number(product.price), image: product.image, quantity: 1 });
		navigate('/megrendeles');
	}

	return (
		<div className="arlista">
			<Seo
				title="Akkuválasztó - Akku 24+"
				description="Válaszd ki a gépjárműved, és megmutatjuk a hozzá illő akkumulátorokat, amelyeket helyben kicserélünk."
			/>

			<Gjkereso prompt="Akku választáshoz és rendeléshez válaszd ki gépjárműved típusát:" target="/akkuvalaszto" />

			<div className="container" style={{ paddingTop: 40 }}>
				{!vehicleId && (
					<p className="note">Válaszd ki a gépjárműved a fenti kereső segítségével, és megmutatjuk a hozzá illő akkumulátorokat.</p>
				)}

				{vehicleId && (
					<div className="arlista__head">
						<h1>Ajánlott akkumulátorok</h1>
						{carLabel && <p>{carLabel}</p>}
					</div>
				)}

				{loading && <p className="note">Akkumulátorok keresése…</p>}

				{vehicleId && !loading && (
					batteries.length === 0 ? (
						<p className="note">Ehhez a gépjárműhöz jelenleg nem találtunk akkumulátort. Kérjük, hívd ügyfélszolgálatunkat: 06 30 626 6000.</p>
					) : (
						<div className="akkulist">
							{batteries.map((p) => <AkkuBox key={p.id} product={p} onOrder={order} />)}
						</div>
					)
				)}
			</div>
		</div>
	);
}
